export default "__VITE_ASSET__BY_ngk_h__"